import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  BottomLinks,
  FooterOuter,
  Link,
  TrademarkSection,
} from './Footer.style';
import { CONSUMER_TERMS_SUPPORTED_LANGUAGES } from 'config';
import { getCompatibleCultureCode } from 'utils/cultureUtils';

const footerLegalLinks = [
  {
    textKey: 'footer.legal.links.resideo',
    linkPath: 'https://resideo.com',
  },
  {
    textKey: 'footer.legal.links.honeywellhome',
    linkPath: 'https://honeywellhome.com',
  },
  {
    textKey: 'footer.legal.links.privacypolicy',
    linkPath: 'https://corporate.resideo.com/privacy/english',
  },
  {
    textKey: 'footer.legal.links.termsconditions',
    linkPath:
      'https://www.resideo.com/us/en/corporate/legal/terms-and-conditions/',
  },
];

const trademarkYear = new Date().getFullYear();

const Footer = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <FooterOuter data-test-footer>
      <BottomLinks data-test-secondary-footer-nav-links>
        {footerLegalLinks.map(function (link): JSX.Element {
          let href = link.linkPath;
          if (link.textKey === 'footer.legal.links.termsconditions') {
            const supportedCultures =
              CONSUMER_TERMS_SUPPORTED_LANGUAGES.split(',').filter(Boolean);
            const culture = getCompatibleCultureCode(
              supportedCultures,
              navigator.languages
            );
            if (culture) {
              href = new URL(culture + '/', link.linkPath).href;
            }
          }
          return (
            <Link href={href} key={link.textKey}>
              {t(link.textKey)}
            </Link>
          );
        })}
      </BottomLinks>
      <TrademarkSection data-test-footer-copyright>
        {t('footer.copyright', { year: trademarkYear })}
      </TrademarkSection>
    </FooterOuter>
  );
};

export default Footer;
